export default __webpack_public_path__ + "static/media/Saibaba5-modified.2e570d29.png";